import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AuroraBackground } from "@/components/AuroraBackground";
import { Logo } from "@/components/Brand";
import { Footer } from "@/components/Footer";
import { COMPANY } from "@/lib/company";

export const LegalSection = ({ id, n, title, children }) => (
  <section id={id} className="scroll-mt-24 mb-9" data-testid={`legal-section-${id}`}>
    <h2 className="font-heading text-xl sm:text-2xl font-bold text-white mb-3 tracking-wide"><span className="text-aurora mr-2">{n}.</span>{title}</h2>
    <div className="text-[15px] text-slate-300 leading-relaxed space-y-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5 [&_strong]:text-white [&_a]:text-cyan-300 [&_a:hover]:underline">{children}</div>
  </section>
);

// Shared shell for legal pages: breadcrumb, anchor index and readable column.
export const LegalLayout = ({ title, subtitle, sections, children, testId }) => (
  <div className="min-h-screen flex flex-col">
    <AuroraBackground />
    <header className="sticky top-0 z-40 px-4 sm:px-8 py-3 border-b border-cyan-500/10 backdrop-blur-xl bg-[#030712]/85 flex items-center gap-3">
      <Logo />
      <Link to="/" data-testid="legal-back-btn" className="ml-auto btn-ghost-hud rounded-full px-3 py-1.5 text-xs flex items-center gap-1.5"><ArrowLeft size={14} /> Torna al sito</Link>
    </header>
    <main className="flex-1 w-full max-w-3xl mx-auto px-4 sm:px-8 py-10" data-testid={testId}>
      <nav className="text-xs font-mono text-slate-500 mb-4" aria-label="breadcrumb">
        <Link to="/" className="hover:text-cyan-300">Home</Link> <span className="mx-1">/</span> <span className="text-slate-300">{title}</span>
      </nav>
      <p className="hud-tag mb-2">{COMPANY.name}</p>
      <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white">{title}</h1>
      <p className="text-sm text-slate-400 mt-2">{subtitle} · Ultimo aggiornamento: {COMPANY.updated}</p>
      <div className="hud-card p-5 mt-6 mb-8" data-testid="legal-toc">
        <p className="hud-tag mb-3">Indice</p>
        <ol className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5 text-sm">
          {sections.map(([id, t], i) => (
            <li key={id}><a href={`#${id}`} className="text-slate-300 hover:text-cyan-300 hover:underline">{i + 1}. {t}</a></li>
          ))}
        </ol>
      </div>
      <article className="hud-card p-5 sm:p-8 max-w-[70ch]">{children}</article>
      <p className="text-xs text-slate-500 mt-6">Il presente documento costituisce una base informativa; per esigenze specifiche è consigliata la verifica di un consulente legale svizzero esperto in LPD e diritto digitale.</p>
    </main>
    <Footer />
  </div>
);
